module.exports = __webpack_public_path__ + "img/Hungary.d4531965.gif";